import { render, staticRenderFns } from "./LoadingPhases.vue?vue&type=template&id=35b4fe80&scoped=true"
import script from "@/controllers/LoadingPhases.ts?vue&type=script&lang=ts&external"
export * from "@/controllers/LoadingPhases.ts?vue&type=script&lang=ts&external"
import style0 from "./LoadingPhases.vue?vue&type=style&index=0&id=35b4fe80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4fe80",
  null
  
)

export default component.exports